import React from "react";
import { useHistory } from "react-router-dom";
import { ErpIntegrationProviderIdResource } from "Shared/util/types";
import { useModal, useTranslation } from "Shared/util/custom-hooks";
import ConfirmationModal from "Shared/components/modals/confirmation-modal";
import { SettingsCard } from "Shared/components/cards";

type FortnoxSettingsCardProps = {
    active: boolean;
    disabled: boolean;
    onDeactivateConfirm: (
        erpIntegrationProvider: ErpIntegrationProviderIdResource,
    ) => void;
    loading: boolean;
    className?: string;
};

const FortnoxSettingsCard = ({
    active,
    disabled,
    onDeactivateConfirm,
    loading,
    className,
}: FortnoxSettingsCardProps) => {
    const history = useHistory();
    const t = useTranslation((x) => x.sales_methods.card);
    const { isModalOpen, openModal, closeModal } = useModal();

    const handleActionClick = () =>
        history.push("/sales-methods/fortnox-setup");
    const handleOnDeactivateConfirm = () =>
        onDeactivateConfirm(ErpIntegrationProviderIdResource.Fortnox);

    return (
        <>
            <SettingsCard
                status={
                    !active
                        ? undefined
                        : {
                              type: "VALID",
                              text: t.active,
                          }
                }
                header={{
                    svg: "/integration/fortnox.svg",
                }}
                content={t.fortnox_description}
                action={
                    disabled
                        ? undefined
                        : {
                              text: active ? t.deactivate : t.get_started,
                              svg: active ? "/trash.svg" : "/caret-right.svg",
                              onClick: active ? openModal : handleActionClick,
                              loading,
                          }
                }
                className={className || ""}
            />

            <ConfirmationModal
                isModalOpen={isModalOpen}
                closeModal={closeModal}
                headerText={t.format(t.deactivate_confirm, {
                    provider: "Fortnox",
                })}
                contentText={t.format(t.deactivate_description, {
                    provider: "Fortnox",
                })}
                confirmText={t.deactivate}
                onConfirm={handleOnDeactivateConfirm}
            />
        </>
    );
};

export default FortnoxSettingsCard;
